import React from "react";

interface ShapeProps {
  imageShape: 'circle' | 'leaf' | 'ellipse';
  color: string;
}

const Shape = ({ imageShape, color, ...props }: ShapeProps): JSX.Element => {
    switch (imageShape) {
      case 'circle':
        return (
          <svg width="111" height="104" viewBox="0 0 111 104" fill="none" xmlns="http://www.w3.org/2000/svg" className={`shape-${imageShape}`} {...props}>
            <path d="M55.5344 101.545C83.1486 101.545 105.534 79.1596 105.534 51.5454C105.534 23.9312 83.1486 1.54539 55.5344 1.54539C27.9202 1.54539 5.5344 23.9312 5.5344 51.5454C5.5344 79.1596 27.9202 101.545 55.5344 101.545Z" fill={color} />
          </svg>
        )
      case 'leaf':
        return (
          <svg width="110" height="93" viewBox="0 0 110 93" fill="none" xmlns="http://www.w3.org/2000/svg" className={`shape-${imageShape}`} {...props}>
            <path 
              d="M53.2477 21.2444C71.0214 18.4078 105.552 34.7446 105.552 34.7446C105.552 34.7446 70.1978 65.5959 55.5607 70.0606C38.3923 74.4812 5.15508 56.5934 5.15508 56.5934C5.15508 56.5934 41.183 23.394 53.2477 21.2444Z" 
              fill={color}
            />
          </svg>
        )
      case 'ellipse':
        return (
          <svg width="116" height="107" viewBox="0 0 116 107" fill="none" xmlns="http://www.w3.org/2000/svg" className={`shape-${imageShape}`} {...props}>
            <path 
              d="M29.75 24.25C13.8718 24.25 0.999998 37.1218 0.999999 53C0.999999 68.8782 13.8718 81.75 29.75 81.75L87.25 81.75C103.128 81.75 116 68.8782 116 53C116 37.1218 103.128 24.25 87.25 24.25L29.75 24.25Z"
              fill={color}/>
          </svg>
        )
      default:
        return (
          <svg width="111" height="104" viewBox="0 0 111 104" fill="none" xmlns="http://www.w3.org/2000/svg" className={`shape-${imageShape}`} {...props}>
            <path d="M55.5344 101.545C83.1486 101.545 105.534 79.1596 105.534 51.5454C105.534 23.9312 83.1486 1.54539 55.5344 1.54539C27.9202 1.54539 5.5344 23.9312 5.5344 51.5454C5.5344 79.1596 27.9202 101.545 55.5344 101.545Z" fill={color} />
          </svg>
        )
    }
  }
  
  export default Shape